// Helper function to format date for datetime-local input
export const formatDateForInput = (dateString: string): string => {
  const date = new Date(dateString);

  // Get local ISO string parts
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  // Format as YYYY-MM-DDThh:mm
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

// Helper function to format date for MySQL (YYYY-MM-DD HH:MM:SS)
export const toMySQLDatetime = (dateValue: string): string => {
  if (!dateValue) return '';
  const date = new Date(dateValue);

  // Get local date parts
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  // Format as YYYY-MM-DD HH:MM:SS
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

// Format date for display to include time
export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
};
